/**
 * Alpine plugin to add Alpine.persistedStore()
 *
 * Forked from @ryangjchandler/fern version 0.1.0
 */
export default function persistedStore(Alpine) {
    if (Alpine.hasOwnProperty('persistedStore') && typeof Alpine.persistedStore === 'function') {
        return;
    }

    window.__ferns = {}

    Alpine.persistedStore = function (name, value) {
        let storageName = name
        const region = window?.accuvars?.region
        if (region && region.toLowerCase() !== 'gb') {
            storageName = `${region.toLowerCase()}_${name}`
        }

        let stored = localStorage.getItem(`__fern_${storageName}`)

        if (! [null, undefined].includes(stored)) {
            const storedValue = JSON.parse(stored)

            const diff = Object.entries(value).reduce((acc, [key, value]) => {
                if (storedValue.hasOwnProperty(key)) return acc
                acc[key] = value
                return acc
            }, {})

            value = Object.assign(storedValue, diff)
        }

        Alpine.store(name, value)

        window.__ferns[name] = Alpine.effect(() => {
            const json = JSON.stringify(
                Alpine.store(name)
            )

            localStorage.setItem(`__fern_${storageName}`, json)
        })
    }
}
